const heroAboutPegasus = {
  title: 'ТОВ «Пегас Армс»',
  paragraphs: [
    'Українська компанія оборонних технологій, яка розробляє, виробляє та впроваджує ударні безпілотні авіаційні комплекси (БпАК), стійкі до засобів радіоелектронної боротьби (РЕБ). Заснована у 2023 році, компанія стала одним із драйверів miltech-сектору, працюючи пліч-о-пліч із Силами оборони України.',
    'Ми робимо українську технологію надійною зброєю, яка допомагає зберегти життя захисників і досягти переваги на полі бою. забезпечуємо українські підрозділи ударними БпЛА, які ефективно виконують бойові завдання навіть в умовах інтенсивного РЕБ — без GPS та зовнішнього керування. ',
  ],
}

export default heroAboutPegasus
